import React, { Component } from "react";
import { Modal, Button } from "semantic-ui-react";
import { getNationwide } from "../coveragearea/Nationwide";
import vehicleDriverslicense from "../../assets/pdfs/vehicle_driverslicense.pdf";
import vehiclesDppa from "../../assets/pdfs/vehicles_dppa.pdf";
import voterRegistration from "../../assets/pdfs/voter_registration.pdf";
import criminalTraffic from "../../assets/pdfs/criminal_traffic.pdf";
import { getCoverageAreaContent } from "../coveragearea/CoverageAreaContent";
import VehiclesDppaComponent from "../coveragearea/VehiclesDppaComponent";

class CoverageArea extends Component {
  state = {
    dialogProps: {
      dialogWidth: "40%",
      dialogHeight: "70%",
      dialogMarginLeft: "30%",
      dialogMarginTop: "100px",
    },
    isVehicleDppaComponent: false,
    content: "",
    isPdf: false,
  };

  componentWillReceiveProps(nextProps) {
    this.prepareCoverageAreaContent(nextProps);
  }

  getDialogProps = (width, height, marginLeft, marginTop) => ({
    dialogWidth: width,
    dialogHeight: height,
    dialogMarginLeft: marginLeft,
    dialogMarginTop: marginTop,
  });

  changeDialogProps = (dialogProps) => {
    this.setState({ dialogProps });
  };

  prepareCoverageAreaContent = (props) => {
    const view = `${props.currentMenuHierarchy[0]}_${props.currentMenuHierarchy[1]}`;
    const lowerCaseView = view.toLowerCase().replace("/", "");
    const lowerCaseNoSpaceView = lowerCaseView.replace(/ /g, "");
    let isVehicleDppaComponent =
      lowerCaseNoSpaceView === "vehicles_vehicledppa" ||
      lowerCaseNoSpaceView === "vehicles_" ||
      lowerCaseNoSpaceView === "vehicles_driverhistory" ||
      lowerCaseNoSpaceView === "vehicles_vin";
    let content = getCoverageAreaContent(
      view,
      lowerCaseNoSpaceView,
      this.changeDialogProps
    );
    let isPdf = false;
    const { leftMenuReportId, currentFormId } = props;
    if (leftMenuReportId === 9 || leftMenuReportId === 68) {
      if (
        currentFormId === 21 ||
        currentFormId === 23 ||
        currentFormId === 17
      ) {
        content = getNationwide();
      }
      if (currentFormId === 9 || currentFormId === 11 || currentFormId === 12) {
        content = (
          <iframe
            title="Vehicles"
            src={vehiclesDppa}
            width="100%"
            height="100%"
          />
        );
        isPdf = true;
        isVehicleDppaComponent = false;
      }
      if (currentFormId === 10) {
        content = (
          <iframe
            title="Vehicles"
            src={vehicleDriverslicense}
            width="100%"
            height="100%"
          />
        );
        isPdf = true;
        isVehicleDppaComponent = false;
      }
    }
    if (leftMenuReportId === 108) {
      content = (
        <iframe
          title="Vehicles"
          src={vehicleDriverslicense}
          width="100%"
          height="100%"
        />
      );
      isPdf = true;
      isVehicleDppaComponent = false;
    }
    if (leftMenuReportId === 114) {
      content = (
        <iframe
          title="Voters"
          src={voterRegistration}
          width="100%"
          height="100%"
        />
      );
      isPdf = true;
    }
    if (leftMenuReportId === 70) {
      content = (
        <iframe
          title="Criminal Traffic"
          src={criminalTraffic}
          width="100%"
          height="100%"
        />
      );
      isPdf = true;
    }

    if (this.state) {
      this.setState({ isPdf, content, isVehicleDppaComponent });
    } else {
      this.state = {
        dialogProps: {
          dialogWidth: "30%",
          dialogHeight: "65%",
          dialogMarginLeft: "35%",
          dialogMarginTop: "100px",
        },
        content,
        isVehicleDppaComponent,
        isPdf,
      };
    }
  };

  render() {
    if (this.state === null || !this.state.content) {
      return null;
    }
    const { dialogProps } = this.state;
    const { userAccount, isLeftSearch } = this.props;
    let buttonClass = "coverage-area-search-button";
    if (userAccount.acctTheme === 0)
      buttonClass =
        "coverageHREF2 orangeShadowBorder darkFont coverage-area-button";
    if (isLeftSearch) {
      buttonClass =
        "coverageHREF2 orangeShadowBorder darkFont coverage-left-search";
    }
    return (
      <Modal
        style={{
          marginTop: `${
            this.state.isPdf ? "5px" : dialogProps.dialogMarginTop
          }`,
          marginLeft: `${
            this.state.isPdf ? "5%" : dialogProps.dialogMarginLeft
          }`,
          width: `${this.state.isPdf ? "90%" : dialogProps.dialogWidth}`,
          height: `${
            this.state.isPdf ? window.height - 100 : dialogProps.dialogHeight
          }`,
        }}
        trigger={
          isLeftSearch ? (
            <div className="text-center">
              <Button
                primary={false}
                className={buttonClass}
                onClick={() => this.props.openCoverageAreaDialog()}
              >
                Coverage area
                {/* {this.props.isLeftSearch ? "Coverage" : "Coverage area"} */}
              </Button>
            </div>
          ) : (
            <Button
              primary={false}
              className={buttonClass}
              onClick={() => this.props.openCoverageAreaDialog()}
            >
              Coverage area
              {/* {this.props.isLeftSearch ? "Coverage" : "Coverage area"} */}
            </Button>
          )
        }
        closeIcon
        open={this.props.active}
        onClose={() => this.props.closeCoverageAreaDialog(this)}
      >
        <Modal.Header>Search Coverage</Modal.Header>
        <Modal.Content
          className={this.state.isPdf ? "coverage-body-pdf" : ""}
          image
          scrolling
        >
          {this.state.isVehicleDppaComponent ? (
            <VehiclesDppaComponent />
          ) : (
            <Modal.Description>{this.state.content}</Modal.Description>
          )}
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <Button
            className={"no-background-color float-right"}
            onClick={() => this.props.closeCoverageAreaDialog(this)}
          >
            Done
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default CoverageArea;



// WEBPACK FOOTER //
// ./src/components/dialogs/CoverageArea.js